export default __webpack_public_path__ + "static/media/Footpad's Jerkin of the Fifth Stage.bdc329f0.jpg";